export const COLUMNS = [
  {
    Header: 'FullName',
    accessor: 'fullName',
  },
  {
    Header: 'FirstName',
    accessor: 'firstName',
  },
  {
    Header: 'LastName',
    accessor: 'lastName',
  },
  {
    Header: 'Email',
    accessor: 'email',
  },
  {
    Header: 'PhoneNumber',
    accessor: 'phoneNumber',
  },
  {
    Header: 'StreetAddress',
    accessor: 'streetAddress',
  },
  {
    Header: 'City',
    accessor: 'city',
  },
  {
    Header: 'POBox',
    accessor: 'poBoxNumber',
  },
  {
    Header: 'Country',
    accessor: 'country',
  },
  {
    Header: 'BusinessName',
    accessor: 'businessName',
  },
  {
    Header: 'ActiveStatus',
    accessor: 'isActive',
  },
  {
    Header: 'Verified',
    accessor: 'isVerified',
  },
  {
    Header: 'Role',
    accessor: 'role',
  },
  {
    Header: 'LastLogin',
    accessor: 'lastLogin',
   
  },
  {
    Header: 'CreatedAt',
    accessor: 'createdAt',
   
  },
  {
    Header: 'UpdatedAt',
    accessor: 'updatedAt',
  },
  {
    Header: 'Edit/Delete',
    accessor: '',
  },
];
